import CurrentShop from './common/currentShop';
import CustomerShopHint from './shop/header/customerShopHint';
import {LanguageNavigation} from './shop/header/languageNavigation';
import MetaNavigation from './shop/header/metaNavigation';
import RecombeeSearch from './shop/header/recombeeSearch';

const currentShop = new CurrentShop();

new LanguageNavigation();

if (currentShop.isDaiberDe()) {
    new MetaNavigation();
    new CustomerShopHint();
}

if (!currentShop.isLoggedInDaiberDe()) {
    new RecombeeSearch();
}
